'use strict';

class Logo {
  constructor(originatorService) {
    this.originatorService = originatorService;
  }

  $onInit() {
    this.image = null;

    this.load();
  }

  $onChanges() {
    this.load();
  }

  load() {
    if (this.id) {
      this.originatorService.getLogo(this.id)
        .then((resp) => {
          if (resp && resp.data) {
            let contentType = resp.headers()['content-type'];
            this.image = `data:${contentType};base64,${resp.data}`;
          }
        });
    }
  }
}

Logo.$inject = ['originatorService'];

const logo = {
  bindings: {
    id: '<'
  },
  controller: Logo,
  template: `
    <img ng-show="$ctrl.image" ng-src="{{ $ctrl.image }}" alt="Logo" />
  `
};

angular
  .module('SendRegning')
  .component('logo', logo);
